import { FC } from 'react';

import SectionLead from '@components_iqfu/public/section_lead/SectionLead';

import styles from './TermsContent.module.scss';

const TermsContent: FC = () => {
  return (
    <>
      <div className={styles.head_title}>
        <SectionLead>イクラ不動産利用規約</SectionLead>
      </div>
      <>
        イクラ株式会社は、不動産の売却を検討している個人のお客様に対し、お客様と宅地建物取引業者をつなぐプラットフォーム上のマッチングサービス「イクラ不動産」（以下「本サービス」といいます）を提供いたします。
        <br />
        ご利用の皆さまは、本サービスをご利用されるにあたり、「イクラ不動産利用規約」（以下「本規約」といいます）の全文をお読み頂いたうえで、本規約の全ての条項について承諾頂く必要があります。
        <br />
        本サービスをご利用頂いた場合、本規約の内容を理解しており、かつ、本規約の全ての条項について承諾したものとみなします。
      </>
      <div className={styles.title}>第1条（用語の定義）</div>
      本規約における用語の意義は次のとおりとします。
      <br />
      <ul className={styles.terms_list}>
        <li className={styles.terms_list__item}>当社：イクラ株式会社</li>
        <li className={styles.terms_list__item}>
          ユーザー：不動産の売却を検討している個人であって、本規約3条に基づき利用登録したお客様
        </li>
        <li className={styles.terms_list__item}>仲介業者：本サービスに登録した宅地建物取引業者</li>
        <li className={styles.terms_list__item}>
          マッチング：仲介業者が選択され、ユーザーと仲介業者とが情報交流できる状態となること
        </li>
        <li className={styles.terms_list__item}>宅建業法：宅地建物取引業法及びその関連法令</li>
        <li className={styles.terms_list__item}>宅建業：宅建業法に基づく不動産売買の媒介（仲介）等</li>
        <li className={styles.terms_list__item}>
          仲介サービス：ユーザーが仲介業者から提供を受ける宅建業法に基づく不動産媒介（仲介）業務
        </li>
        <li className={styles.terms_list__item}>
          成約：マッチングの後に仲介業者の仲介サービスにより、ユーザー（ユーザーと同視できる者も含む）の不動産売却に係る契約（当該仲介業者が直接買取をする契約も含む）が成立すること
        </li>
      </ul>
      <div className={styles.title}>第2条（適用）</div>
      本規約は、ユーザーと当社との間における本サービスの利用に関わる一切の関係に適用されるものとします。
      <br />
      本サービスは、日本国内居住者及び日本国内不動産について適用されるものとします。
      <div className={styles.title}>第3条（利用登録）</div>
      ユーザーは、本サービスを利用するためには、利用登録を行う必要があります。 <br />
      利用登録は無料です。
      <br />
      ユーザーは、当社の定める方法によって利用登録を申請し、当社がこれを承認することによって、利用登録が完了します。
      <br />
      当社は、利用登録の申請に関し以下の事由があると判断した場合、利用登録の申請を承認しないことがあり、その理由については一切の開示義務を負わないものとします。
      <ul className={styles.terms_list}>
        <li className={styles.terms_list__item}>利用登録の申請に際して虚偽の事項を届け出た場合</li>
        <li className={styles.terms_list__item}>本規約に違反したことがある者からの申請である場合</li>
        <li className={styles.terms_list__item}>反社会的勢力に該当することが判明した場合</li>
        <li className={styles.terms_list__item}>その他、当社が利用登録を相当でないと判断した場合</li>
      </ul>
      <div className={styles.title}>第4条（ユーザーIDおよびパスワードの管理）</div>
      利用登録完了後、当社は、ユーザーに本サービスのユーザーID及びパスワードを発行します。
      <br />
      ユーザーは、自己の責任において、本サービスのユーザーIDおよびパスワードを管理するものとします。
      <br />
      ユーザーは、いかなる場合にも、ユーザーIDおよびパスワードを第三者に譲渡または貸与することはできません。当社は、ユーザーIDとパスワードの組み合わせが登録情報と一致したログインがあった場合には、そのユーザーIDを登録しているユーザー自身による利用とみなします。
      <div className={styles.title}>第5条（本サービスの利用）</div>
      利用登録後の本サービスの利用は無料です。
      <br />
      ユーザーは本サービスの利用にあたって、次の事項を確認・承諾するものとします。
      <ul className={styles.terms_list}>
        <li className={styles.terms_list__item}>
          本サービスはユーザーと仲介業者とのマッチングを目的とするものであり、本サービス自体は宅建業に該当しないこと。
        </li>
        <li className={styles.terms_list__item}>
          当社は、本サービスを提供するにあたり、仲介業者とのマッチングの成功、仲介サービス提供の機会の確保、成約の機会の確保等について一切保証するものではないこと。
        </li>
        <li className={styles.terms_list__item}>ユーザーは、自己の責任と判断において仲介業者を選択すること。</li>
        <li className={styles.terms_list__item}>
          当社は、マッチング後の仲介サービス、成約に関し一切責任を負わないこと。
        </li>
        <li className={styles.terms_list__item}>
          ユーザーは、成約に際し、自己の責任と判断において売買契約等を締結すること。
        </li>
        <li className={styles.terms_list__item}>
          成約に際しては、成約に至る仲介サービスを提供した仲介業者に対し、仲介サービスにかかる契約に基づく仲介手数料または報酬を支払う必要があること。
        </li>
        <li className={styles.terms_list__item}>
          ユーザーと仲介業者または成約の相手方、その他第三者との間に紛争・トラブル等が発生した場合においても、当社はそれらに関与せず一切の責任を負わないこと。
        </li>
        <li className={styles.terms_list__item}>
          利用登録にあたり、当社が取得したユーザーに関する情報（別途定めるプライバシーポリシーに定める個人情報を含む）が、本サービスの趣旨に従って本サービスを利用する仲介業者に提供されること。
        </li>
      </ul>
      <div className={styles.title}>第6条（ユーザーの当社への通知義務）</div>
      ユーザーは、本サービスにより成約に至った場合は、当社の定める方法によりその旨（成約価格、決済予定日を含む）を当社に直ちに報告しなければなりません。ユーザーは、本条に基づく報告において、虚偽の事項を報告してはならないものとします。
      <div className={styles.title}>第7条（禁止事項）</div>
      ユーザーは、本サービスの利用にあたり、以下の行為をしてはなりません。
      <ul className={styles.terms_list}>
        <li className={styles.terms_list__item}>法令または公序良俗に違反する行為</li>
        <li className={styles.terms_list__item}>犯罪行為に関連する行為</li>
        <li className={styles.terms_list__item}>
          当社のサーバーまたはネットワークの機能を破壊したり、妨害したりする行為
        </li>
        <li className={styles.terms_list__item}>当社のサービスの運営を妨害するおそれのある行為</li>
        <li className={styles.terms_list__item}>他のユーザーに関する個人情報等を収集または蓄積する行為</li>
        <li className={styles.terms_list__item}>他のユーザーに成りすます行為</li>
        <li className={styles.terms_list__item}>
          当社のサービスに関連して、反社会的勢力に対して直接または間接に利益を供与する行為
        </li>
        <li className={styles.terms_list__item}>本規約の各条項に反する行為</li>
        <li className={styles.terms_list__item}>本サービスにかかるレビュー欄に以下の投稿をする行為</li>
        <ul className={styles.terms_list}>
          <li className={styles.list_inside}>①本サービスに関わりのない投稿</li>
          <li className={styles.list_inside}>②第三者（仲介業者を含む）を誹謗中傷等する投稿</li>
          <li className={styles.list_inside}>③虚偽の事実に関する投稿</li>
          <li className={styles.list_inside}>④広告、宣伝等営利を目的とした投稿</li>
          <li className={styles.list_inside}>⑤個人のプライバシーに関する投稿</li>
          <li className={styles.list_inside}>⑥本サービスの円滑な運用を妨げる内容の投稿</li>
          <li className={styles.list_inside}>⑦その他当社が不適切であると判断する投稿</li>
        </ul>
        <li className={styles.terms_list__item}>前各号の他、当社が不適切と判断する行為</li>
      </ul>
      ユーザーは、上記各号の行為により当社に損害を生じさせたときは、その損害を賠償しなければなりません。
      <br />
      当社は、ユーザーが本サービスにかかるレビュー欄に上記第9号に掲げる各投稿をしたときは、当該投稿をユーザーの承諾なく削除することができ、ユーザーは当該削除に対して異議を述べることができません。
      <div className={styles.title}>第8条（本サービスの提供の停止等）</div>
      当社は、以下のいずれかに該当する場合には、ユーザーに事前に通知することなく、本サービスの全部又は一部の提供を停止または中断することができるものとします。
      <ul className={styles.terms_list}>
        <li className={styles.terms_list__item}>システムの点検又は保守を緊急に行う場合</li>
        <li className={styles.terms_list__item}>
          コンピューター、通信回線が事故や第三者からの攻撃によって停止した場合
        </li>
        <li className={styles.terms_list__item}>
          地震、落雷、火災などの不可抗力によって本サービスの運営ができなくなった場合
        </li>
        <li className={styles.terms_list__item}>その他、当社が停止または中断を行う必要があると判断した場合</li>
      </ul>
      当社は、本条に基づき当社が行った措置によりユーザーに生じた損害について、一切の責任を負いません。
      <div className={styles.title}>第9条（利用制限および登録抹消）</div>
      当社は、ユーザーが以下のいずれかに該当する場合には、事前の通知なく、ユーザーに対して、本サービスの全部もしくは一部の利用を制限、またはユーザーとしての利用登録を抹消することができるものとします。
      <ul className={styles.terms_list}>
        <li className={styles.terms_list__item}>本規約のいずれかの条項に違反した場合</li>
        <li className={styles.terms_list__item}>登録事項に虚偽の事実があることが判明した場合</li>
        <li className={styles.terms_list__item}>反社会的勢力に該当することが判明した場合</li>
        <li className={styles.terms_list__item}>その他、当社が本サービスの利用を適当でないと判断した場合</li>
      </ul>
      当社は、本条に基づき当社が行った措置によりユーザーに生じた損害について、一切の責任を負いません。
      <div className={styles.title}>第10条（当社の責任）</div>
      本サービスの利用にあたり、当社の故意または過失によってユーザーに損害を生じさせた場合、当社はその損害を賠償します。ただし、当社に故意または重過失がある場合を除き、当社が損害を賠償する範囲は通常損害に限り、かつ金３万円を上限とします。
      <br />
      なお、上記にかかわらず、本規約第5条(2)のとおり、当社はマッチングの成功等の保証をするものでなく、本規約第5条(4)のとおり、当社はマッチング後の仲介サービス等について一切責任を負わず、本規約第5条(7)のとおり、当社は本サービスに関して、ユーザーと仲介業者または成約の相手方、その他第三者との間において生じたトラブル、紛争等についても一切責任を負いません。
      <div className={styles.title}>第11条（サービス内容の変更等）</div>
      当社は、当社の都合により、本サービスの内容を変更、または本サービスの提供を終了することができるものとします。当社が本サービスの提供を終了する場合には、当社は、ユーザーに事前に通知するものとします。
      <div className={styles.title}>第12条（利用規約の変更）</div>
      当社は、必要と判断した場合には、民法第548条の2以下の定めに則り、定型約款としての本規約を変更することができるものとします。
      <div className={styles.title}>第13条（通知または連絡）</div>
      当社が行うユーザーに対する通知または連絡は、別途当社の定める方法によって行うものとします。なお、当社がユーザーの利用登録において登録されたメールアドレス等の連絡先（LINE、SMSを含みますが、これらに限られません。）に対して通知または連絡をした場合は、ユーザーはその通知または連絡を受領したものとみなします。
      <div className={styles.title}>第14条（権利義務の譲渡の禁止）</div>
      当社は本規約第3条により利用登録をしたユーザーについてのみ本サービスの利用を許諾するものであり、ユーザーは、契約上の地位または本規約に基づく権利もしくは義務を第三者に譲渡することはできません。
      <div className={styles.title}>第15条（利用の終了）</div>
      ユーザーは、当社の定める方法により申し出ることにより、ユーザーとしての利用登録を抹消し、本サービスの利用を終了することができます。ただし、本サービスの利用終了から2年間は、第6条の通知義務は存続します。
      <div className={styles.title}>第16条（準拠法・裁判管轄）</div>
      本規約の解釈にあたっては、日本法を準拠法とします。
      <br />
      本サービスに関して紛争が生じた場合には、当社の本店所在地を管轄する裁判所を専属的合意管轄とします。
      <br />
      <br />
      <div className={styles.revised_date}>【2015年9月1日制定】</div>
      <div className={styles.revised_date}>【2022年8月26日改定】</div>
    </>
  );
};

export default TermsContent;
